







import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import { DYNAMIC_FORM_FIELD_PROPS } from '~/constants/dynamic-form'
import { useDynamicForm } from '~/compositions/dynamic-form'
import { useI18n } from '~/compositions/i18n'

export default defineComponent({
  props: DYNAMIC_FORM_FIELD_PROPS,
  setup(props) {
    const { name, context } = toRefs(props)

    const { value, changeValue } = useDynamicForm(props)
    const { t } = useI18n()
    const label = computed(() => {
      switch (name.value) {
        case 'active':
        case 'activated': {
          if (context.value === 'auditor') {
            return t('active::male')
          }
          return t('active')
        }
        default: {
          return ''
        }
      }
    })

    function handleCheckboxInput(val: boolean) {
      changeValue(name.value, val)
    }

    return { label, handleCheckboxInput, value }
  }
})
